export default __webpack_public_path__ + "static/media/testimonial-01.ed579fb9.jpeg";